import { map } from 'lodash'

import fileAssets from '@/assets/files/'

const playerLocationX = 8
const playerLocationY = 12

const files = map(fileAssets, (fileAssetDetails, fileSlug) => {
  return fileSlug
})

export default {
  state: {

    // dashboardWidgets: {
    //   clock: true,
    //   decoder: false,
    //   notebook: true,
    //   amRadio: true,
    //   fmRadio: false
    // },

    // Time
    inGameHours: 10,
    inGameMinutes: 23,

    // Player
    playerLocationX,
    playerLocationY,

    // Load all files
    // NOTE: this is more for debugging until we figure out how to use files
    // NOTE: we could have multiple files that refer to the same asset (or support multi-asset file types)
    files: [].concat(files, files, files, files, files, files, files, files),

    radios: [

      // Player radios
      // NOTE: we're not mapping IDs: the game will treat any radio in the same location as player's
      {
        locationX: playerLocationX,
        locationY: playerLocationY,
        maxFrequency: 40,
        range: 10
      },
      {
        locationX: playerLocationX,
        locationY: playerLocationY,
        maxFrequency: 120,
        minFrequency: 80,
        range: 6
      },

      // World radios
      {
        isOn: false,
        locationX: 6,
        locationY: 5,
        frequency: 94.23,
        maxFrequency: 120,
        minFrequency: 80,
        range: 6
      }
    ]
  }
}
